import { CoupomCustomization } from './customization';
import { VtexProviderCoupom } from './vtex-provider-coupom';

export class Coupom {
  id: string;

  code: string;

  name: string;

  source: string;

  coupom_source_id: string;

  customization: CoupomCustomization;

  created_at: Date;

  updated_at: Date;

  sync?: boolean;

  coupom?: VtexProviderCoupom;

  constructor(data: Coupom) {
    this.id = data.id;
    this.code = data.code;
    this.name = data.name;
    this.source = data.source;
    this.coupom_source_id = data.coupom_source_id;
    this.created_at = new Date(data.created_at.toString());
    this.updated_at = new Date(data.updated_at.toString());
    this.customization = new CoupomCustomization(data.customization);
    this.sync = data.sync;
    this.coupom = data.coupom && new VtexProviderCoupom(data.coupom);
  }
}
